import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as core from "./core.js";
import * as errors from "./errors.js";
import * as util from "./util.js";
export const _parse = _Err => (schema, value, _ctx, _params) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    async: false
  }) : {
    async: false
  };
  const result = schema._zod.run({
    value,
    issues: []
  }, ctx);
  if (result instanceof Promise) {
    throw new core.$ZodAsyncError();
  }
  if (result.issues.length) {
    var _params$Err;
    const e = new ((_params$Err = _params === null || _params === void 0 ? void 0 : _params.Err) !== null && _params$Err !== void 0 ? _params$Err : _Err)(result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config())));
    util.captureStackTrace(e, _params === null || _params === void 0 ? void 0 : _params.callee);
    throw e;
  }
  return result.value;
};
export const parse = /* @__PURE__*/_parse(errors.$ZodRealError);
export const _parseAsync = _Err => async (schema, value, _ctx, params) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    async: true
  }) : {
    async: true
  };
  let result = schema._zod.run({
    value,
    issues: []
  }, ctx);
  if (result instanceof Promise) result = await result;
  if (result.issues.length) {
    var _params$Err2;
    const e = new ((_params$Err2 = params === null || params === void 0 ? void 0 : params.Err) !== null && _params$Err2 !== void 0 ? _params$Err2 : _Err)(result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config())));
    util.captureStackTrace(e, params === null || params === void 0 ? void 0 : params.callee);
    throw e;
  }
  return result.value;
};
export const parseAsync = /* @__PURE__*/_parseAsync(errors.$ZodRealError);
export const _safeParse = _Err => (schema, value, _ctx) => {
  const ctx = _ctx ? _objectSpread(_objectSpread({}, _ctx), {}, {
    async: false
  }) : {
    async: false
  };
  const result = schema._zod.run({
    value,
    issues: []
  }, ctx);
  if (result instanceof Promise) {
    throw new core.$ZodAsyncError();
  }
  return result.issues.length ? {
    success: false,
    error: new (_Err !== null && _Err !== void 0 ? _Err : errors.$ZodError)(result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config())))
  } : {
    success: true,
    data: result.value
  };
};
export const safeParse = /* @__PURE__*/_safeParse(errors.$ZodRealError);
export const _safeParseAsync = _Err => async (schema, value, _ctx) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    async: true
  }) : {
    async: true
  };
  let result = schema._zod.run({
    value,
    issues: []
  }, ctx);
  if (result instanceof Promise) result = await result;
  return result.issues.length ? {
    success: false,
    error: new _Err(result.issues.map(iss => util.finalizeIssue(iss, ctx, core.config())))
  } : {
    success: true,
    data: result.value
  };
};
export const safeParseAsync = /* @__PURE__*/_safeParseAsync(errors.$ZodRealError);
export const _encode = _Err => (schema, value, _ctx) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    direction: "backward"
  }) : {
    direction: "backward"
  };
  return _parse(_Err)(schema, value, ctx);
};
export const encode = /* @__PURE__*/_encode(errors.$ZodRealError);
export const _decode = _Err => (schema, value, _ctx) => {
  return _parse(_Err)(schema, value, _ctx);
};
export const decode = /* @__PURE__*/_decode(errors.$ZodRealError);
export const _encodeAsync = _Err => async (schema, value, _ctx) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    direction: "backward"
  }) : {
    direction: "backward"
  };
  return _parseAsync(_Err)(schema, value, ctx);
};
export const encodeAsync = /* @__PURE__*/_encodeAsync(errors.$ZodRealError);
export const _decodeAsync = _Err => async (schema, value, _ctx) => {
  return _parseAsync(_Err)(schema, value, _ctx);
};
export const decodeAsync = /* @__PURE__*/_decodeAsync(errors.$ZodRealError);
export const _safeEncode = _Err => (schema, value, _ctx) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    direction: "backward"
  }) : {
    direction: "backward"
  };
  return _safeParse(_Err)(schema, value, ctx);
};
export const safeEncode = /* @__PURE__*/_safeEncode(errors.$ZodRealError);
export const _safeDecode = _Err => (schema, value, _ctx) => {
  return _safeParse(_Err)(schema, value, _ctx);
};
export const safeDecode = /* @__PURE__*/_safeDecode(errors.$ZodRealError);
export const _safeEncodeAsync = _Err => async (schema, value, _ctx) => {
  const ctx = _ctx ? Object.assign(_ctx, {
    direction: "backward"
  }) : {
    direction: "backward"
  };
  return _safeParseAsync(_Err)(schema, value, ctx);
};
export const safeEncodeAsync = /* @__PURE__*/_safeEncodeAsync(errors.$ZodRealError);
export const _safeDecodeAsync = _Err => async (schema, value, _ctx) => {
  return _safeParseAsync(_Err)(schema, value, _ctx);
};
export const safeDecodeAsync = /* @__PURE__*/_safeDecodeAsync(errors.$ZodRealError);